import * as React from 'react'
import { clsx } from 'clsx'
import { IS_APPLE } from 'platejs'
import type { TMentionElement } from 'platejs'
import { PlateElement } from 'platejs/react'
import type { PlateElementProps } from 'platejs/react'

import styles from './MentionElement.module.css'

type RichTextFieldMentionElement = TMentionElement & {
  trigger?: string
  type: 'mention'
}

const MentionElement = React.forwardRef<
  HTMLSpanElement,
  PlateElementProps<RichTextFieldMentionElement>
>(({ children, className, element, ...props }, ref) => {
  const [mounted, setMounted] = React.useState(false)
  React.useEffect(() => setMounted(true), [])
  const childrenFirst = mounted && IS_APPLE

  return (
    <PlateElement
      {...props}
      ref={ref}
      as="span"
      attributes={{ ...props.attributes, contentEditable: false }}
      className={clsx(styles.mention, className)}
      element={element}
    >
      {/* Slate's spacer must precede the label for Apple IME composition. */}
      {childrenFirst && children}
      {element.trigger ?? '@'}
      {element.value}
      {!childrenFirst && children}
    </PlateElement>
  )
})

MentionElement.displayName = 'RichTextField.MentionElement'

export { MentionElement }
export type { RichTextFieldMentionElement }
